// 导入axios接口
import axiosRequest from '@/utils/axios-default-request';

// 字典  appeal_status获取申诉状态  appeal_type 申诉类型
let getDictTypeData = (data) => axiosRequest.postBody('/supinterface/getDictTypeData', data);


// 需求端
// 申诉列表查询
let getAppealList = (data) => axiosRequest.postBodyJson('/clientinterface/getAppealList', data);
// 创建申诉
let addAppeal = (data) => axiosRequest.postBodyJson('/clientinterface/addAppeal', data);
// 申诉详情
let getAppealIdData = (data) => axiosRequest.postBody('/clientinterface/getAppealIdData', data);


// 译员端------------------------------------------------------------------------------------------------
// 申诉列表查询 译员
let getAppealListYY = (data) => axiosRequest.postBodyJson('/supinterface/getAppealList', data);
// 申诉详情
let getAppealIdDataYY = (data) => axiosRequest.postBody('/supinterface/getAppealIdData', data);
// 创建申诉
let addAppealYY = (data) => axiosRequest.postBodyJson('/supinterface/addAppeal', data);

export default {
    // 字典
    getDictTypeData,

    // 需求端
    getAppealList,// 获取订单列表信息
    addAppeal,// 创建申诉
    getAppealIdData,//申诉详情

    // 译员端------------------
    getAppealListYY,
    getAppealIdDataYY,
    addAppealYY,

}